import { useEffect } from 'react';
import authenticatedRouter from '@/router/Panel';
import notAuthenticatedRouter from '@/router/Auth';
import { useAuth } from '@/providers/AuthContext';
import { createBrowserRouter } from 'react-router-dom';

const useBrowserRouter = () => {
  const { isAuth, logout } = useAuth();
  const router = createBrowserRouter(
    isAuth ? authenticatedRouter : notAuthenticatedRouter,
  );
  useEffect(() => {
    const handleNavigate = (e: Event) => {
      const navigateEventDetail = (e as NavigateEvent).detail;
      Promise.resolve()
        .then(() => {
          logout();
        })
        .then(() => {
          router?.navigate(navigateEventDetail?.path);
        });
    };
    window.addEventListener('navigateEvent', handleNavigate);
    return () => {
      window.removeEventListener('navigateEvent', handleNavigate);
    };
  }, [logout, router]);
  return router;
};

export default useBrowserRouter;
